import { render, staticRenderFns } from "./CardDetailAddress.vue?vue&type=template&id=0acdf906&scoped=true&"
import script from "./CardDetailAddress.vue?vue&type=script&lang=js&"
export * from "./CardDetailAddress.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailAddress.vue?vue&type=style&index=0&id=0acdf906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acdf906",
  null
  
)

export default component.exports